/**
 * Created by richardlovejoy on 2/11/17.
 */
import config from '../constants/Config';
import SoundControlWidget from './SoundControlWidget';


/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const SplashScreen = function(game) {

  Phaser.Group.call(this, game);
  this.name = "SplashScreen";

};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
SplashScreen.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: SplashScreen,

  /////////////////////////////////////////////////////////////////////////
  // INTERFACE ////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  /**
   *
   */
  init: function() {

    this.bg = this.game.add.image(0, 0, 'splash', null, this);
    this.bgAspect = this.bg.width/this.bg.height;
    this.baseWidth = this.bg.width;
    this.baseHeight = this.bg.height;

    this.logo = this.game.add.image(0, 0, 'skee', 'SkeeLogo.png', this);
    this.logo.anchor.set(0.5, 0);

    this.lotteryLogo = this.game.add.image(0, 0, 'loading', config.lottery+'L_logo1.png', this);
    this.lotteryLogo.anchor.set(0.5);
    this.lotteryLogo.visible = (config.lottery !== 'demo');

    this.playButton = this.game.add.button(0, 0, 'skee', this.playButtonPressed, this, 'playButton.png', 'playButton.png', null, null, this);
    this.playButton.anchor.set(0.5, 0);

    this.soundFxToggle = new SoundControlWidget(this.game, 'soundFxLabel.png', 'fxVolume');
    this.musicToggle = new SoundControlWidget(this.game, 'soundLabel.png', 'musicVolume', 0.1);

    this.soundFxToggle.x = this.musicToggle.x = 12;
    this.soundFxToggle.y = 24;

    this.musicToggle.y = 64;

    this.add(this.soundFxToggle);
    this.add(this.musicToggle);

    // GA
    /*
    this.ticketGraphic = this.game.add.image(0, 0, 'skee', 'ticketGrphic.png', this);
    */

    // hidden initially
    this.visible = false;

  }, // end Init

  reset: function() {

  },

  show: function() {
    this.visible = true;
    this.alpha = 0;
    this.playButton.visible = false;

    this.game.add.tween(this).to({alpha: 1}, 500, Phaser.Easing.Linear.None, true);
  },

  hide: function() {
    this.game.add.tween(this).to({alpha: 0}, 300, Phaser.Easing.Linear.None, true).onComplete.add(() => {
      this.visible = false;
    });
  },

  showPlayButton: function() {

    this.playButton.alpha = 0;
    this.playButton.visible = true;

    this.game.add.tween(this.playButton).to({alpha: 1}, 500, Phaser.Easing.Linear.None, true);

  },

  frameUpdate: function() {

  },

  draw: function() {

    var w = this.game.width;
    var h = this.game.height;

    // size bg to fill the screen, unless in portrait, then fan out left/right
    if (this.game.sizeManager.isPortrait) {
      this.bg.height = h;
      this.bg.width = this.bgAspect * this.bg.height;
      this.bg.x = (w-this.bg.width) / 2;
      this.bg.y = 0;

      if (this.ticketGraphic) {
        this.ticketGraphic.scale.set(1);
        if (this.ticketGraphic.height > h * 0.4) {
          this.ticketGraphic.scale.set(0.8);
          this.ticketGraphic.y += 40;
        }
      }

      // GA
      /*
      this.ticketGraphic.x = (w - this.ticketGraphic.width) / 2;
      this.ticketGraphic.y = h - (this.ticketGraphic.height + 30);
      */

      this.logo.x = this.playButton.x = w/2;

      this.lotteryLogo.scale.set(0.8);
      this.lotteryLogo.x = w - (this.lotteryLogo.width/2 + 20);
      this.lotteryLogo.y = 10 + this.lotteryLogo.height/2;

      this.logo.scale.set((h > 800) ? 0.8 : 0.7);
      this.logo.y = h/2 - this.logo.height - 125;
      this.playButton.y = h/2 - this.playButton.height/2;

    } else {

      this.bg.width = w;
      this.bg.height = (h > this.baseHeight) ? h : this.baseHeight;
      this.bg.x = 0;
      this.bg.y = (h-this.bg.height) / 2;

      // GA
      // scale the ticket on landscape
      /*
      var ticketScale = (w < 1200) ? ((w * 0.27) / 375) : 1.0;

      this.ticketGraphic.scale.set(ticketScale);
      this.ticketGraphic.x = 20;
      this.ticketGraphic.y = (h - this.ticketGraphic.height) / 2;
      */

      this.logo.x = this.playButton.x = this.lotteryLogo.x = w/2;
      this.lotteryLogo.scale.set(1);
      if (config.lottery === 'demo') {
        this.logo.y = h/2 - this.logo.height;
        this.playButton.y = this.logo.y + 410;
      } else {
        this.lotteryLogo.y = h/2;
        this.logo.scale.set((h > 800) ? 0.8 : 0.7);
        this.logo.y = h/2 - this.logo.height - 125;
        this.playButton.y = this.lotteryLogo.y + this.lotteryLogo.height * 0.7;
      }

    }

    // place other elements - logo's bottom is at center
    if (0) {
      this.logo.x = this.playButton.x = this.lotteryLogo.x = w/2;
      if (config.lottery === 'demo') {
        this.logo.y = h/2 - this.logo.height;
        this.playButton.y = this.logo.y + 410;
      } else {
        this.lotteryLogo.y = h/2;
        this.logo.scale.set((h > 800) ? 0.8 : 0.7);
        this.logo.y = h/2 - this.logo.height - 125;
        this.playButton.y = this.lotteryLogo.y + this.lotteryLogo.height * 0.7;
      }
    }

  },

  playButtonPressed: function() {
    // fix Chrome issue to turn on sound
    if (this.game.sound.usingWebAudio &&
      this.game.sound.context.state === 'suspended')
    {
      this.game.sound.context.resume();
    }

  }

  /////////////////////////////////////////////////////////////////////////
  // HELPERS //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
});

export default SplashScreen;



// WEBPACK FOOTER //
// ./app/src/display/SplashScreen.js